import React, { Component } from 'react';

// Externals
import classNames from 'classnames';
import PropTypes from 'prop-types';

// Material helpers
import { withStyles } from '@material-ui/core';

// Material components
import { Typography } from '@material-ui/core';

// Material icons
import {
  ArrowUpward as ArrowUpwardIcon,
  ArrowDownward as ArrowDownwardIcon,
  PeopleOutlined as PeopleIcon
} from '@material-ui/icons';

// Shared components
import { Paper } from 'components';

// Component styles
import styles from './styles';

import api from '../../../../api';

function getTS(daysMinus) {
  let date = new Date();
  date.setDate(new Date().getDate()-daysMinus);
  date.setUTCHours(0);
  date.setUTCMinutes(0);
  date.setUTCSeconds(0);
  date.setUTCMilliseconds(0);
  return Math.floor(date.getTime() / 1000);
}

class Impressions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      impressions:0,
      impressionGrowth:0
    }
  }

  componentDidMount() {
    this.requestData();
  }

  componentWillReceiveProps(next) {
    this.requestData(next);
  }

  async requestData(props) {
    props = props || this.props;
    //let res = await api.getImpression('all', 'all')
    //let resLast = 0
    let res = await api.getChartCount('all', getTS(8), getTS(2));
    let resLast = await api.getChartCount('all', getTS(15), getTS(9));
    console.log(res);
    console.log(resLast);
    let sum = 0;
    let sumLastWeek = 0;
    if(res)
      sum = res.data.data.success || 0;
    if(resLast)
      sumLastWeek = resLast.data.data.success || 0;
    if(res.error){
      throw res.error;
    }
    if(resLast.error){
      throw resLast.error;
    }
    if(sumLastWeek === 0) {
      sumLastWeek = 1;
    }
    this.setState({
      impressions: sum,
      impressionGrowth: ((sum-sumLastWeek)/sumLastWeek).toFixed(3)*100.0
    });
  }

  render() {
    const { classes, className, ...rest } = this.props;

    const rootClassName = classNames(classes.root, className);

    return (
      <Paper
        {...rest}
        className={rootClassName}
      >
        <div className={classes.content}>
          <div className={classes.details}>
            <Typography
              className={classes.title}
              variant="body2"
            >
              TOTAL IMPRESSION LAST HOUR
            </Typography>
            <Typography
              className={classes.value}
              variant="h3"
            >
              {this.state.impressions}
            </Typography>
          </div>
          <div className={classes.iconWrapper}>
            <PeopleIcon className={classes.icon} />
          </div>
        </div>
        <div className={classes.footer}>
          
          <Typography
            className={this.state.impressionGrowth>=0?classes.differenceIncrease:classes.differenceDecrease}
            variant="body2"
          >
            {this.state.impressionGrowth>=0?<ArrowUpwardIcon />:<ArrowDownwardIcon />}
            {this.state.impressionGrowth}%
          </Typography>
          <Typography
            className={classes.caption}
            variant="caption"
          >
            Since last hour
          </Typography>
        </div>
      </Paper>
    );
  }
}

Impressions.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Impressions);
